define("settings/components/billing-section", ["exports", "@ember/component", "ember-concurrency/async-arrow-runtime", "@ember/service", "@glimmer/component", "ember-concurrency", "later/utils/compare-strings", "@ember/template-factory"], function (_exports, _component, _asyncArrowRuntime, _service, _component2, _emberConcurrency, _compareStrings, _templateFactory) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  var _class, _descriptor;
  0; //eaimeta@70e063a35619d71f0,"ember-concurrency/async-arrow-runtime",0,"ember-cli-htmlbars",0,"@ember/service",0,"@glimmer/component",0,"ember-concurrency",0,"later/utils/compare-strings",0,"@ember/component"eaimeta@70e063a35619d71f
  function _initializerDefineProperty(target, property, descriptor, context) { if (!descriptor) return; Object.defineProperty(target, property, { enumerable: descriptor.enumerable, configurable: descriptor.configurable, writable: descriptor.writable, value: descriptor.initializer ? descriptor.initializer.call(context) : void 0 }); }
  function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
  function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
  function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
  function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }
  function _initializerWarningHelper(descriptor, context) { throw new Error('Decorating class property failed. Please ensure that ' + 'transform-class-properties is enabled and runs after the decorators transform.'); }
  const __COLOCATED_TEMPLATE__ = (0, _templateFactory.createTemplateFactory)(
  /*
    {{! @glint-nocheck: not typesafe yet }}
  <Section
    @badge={{@badge}}
    @qaClass="qa--subHeader_billing"
    @title={{t "account.billing.section_title"}}
    {{did-insert (perform this.loadPayments)}}
    as |section|
  >
  
    <section.wrapper>
      {{#if this.hasBillingErrors}}
        <section.details
          @description={{t "account.billing.error"}}
          @descriptionStyles="u--text--danger"
          @title={{t "account.billing.title"}}
          @titleStyles="u--text--md u--text--danger"
        />
      {{else}}
        <section.details
          @description={{t "account.billing.description"}}
          @descriptionStyles="u--text--light"
          @title={{t "account.billing.title"}}
          @titleStyles="u--text--md"
        />
      {{/if}}
      <section.action @buttonRoute="subscription.billing" @buttonText={{t "account.billing.button"}} />
    </section.wrapper>
  
  </Section>
  */
  {
    "id": "g7VNXywW",
    "block": "[[[8,[39,0],[[4,[38,2],[[28,[37,3],[[30,0,[\"loadPayments\"]]],null]],null]],[[\"@badge\",\"@qaClass\",\"@title\"],[[30,1],\"qa--subHeader_billing\",[28,[37,1],[\"account.billing.section_title\"],null]]],[[\"default\"],[[[[1,\"\\n\\n  \"],[8,[30,2,[\"wrapper\"]],null,null,[[\"default\"],[[[[1,\"\\n\"],[41,[30,0,[\"hasBillingErrors\"]],[[[1,\"      \"],[8,[30,2,[\"details\"]],null,[[\"@description\",\"@descriptionStyles\",\"@title\",\"@titleStyles\"],[[28,[37,1],[\"account.billing.error\"],null],\"u--text--danger\",[28,[37,1],[\"account.billing.title\"],null],\"u--text--md u--text--danger\"]],null],[1,\"\\n\"]],[]],[[[1,\"      \"],[8,[30,2,[\"details\"]],null,[[\"@description\",\"@descriptionStyles\",\"@title\",\"@titleStyles\"],[[28,[37,1],[\"account.billing.description\"],null],\"u--text--light\",[28,[37,1],[\"account.billing.title\"],null],\"u--text--md\"]],null],[1,\"\\n\"]],[]]],[1,\"    \"],[8,[30,2,[\"action\"]],null,[[\"@buttonRoute\",\"@buttonText\"],[\"subscription.billing\",[28,[37,1],[\"account.billing.button\"],null]]],null],[1,\"\\n  \"]],[]]]]],[1,\"\\n\\n\"]],[2]]]]]],[\"@badge\",\"section\"],false,[\"section\",\"t\",\"did-insert\",\"perform\",\"if\"]]",
    "moduleName": "settings/components/billing-section.hbs",
    "isStrictMode": false
  });
  let BillingSectionComponent = _exports.default = (_class = class BillingSectionComponent extends _component2.default {
    constructor() {
      super(...arguments);
      _initializerDefineProperty(this, "payment", _descriptor, this);
      _defineProperty(this, "payments", []);
      _defineProperty(this, "loadPayments", (0, _asyncArrowRuntime.buildTask)(() => ({
        context: this,
        generator: function* () {
          this.payments = yield this.payment.retrieve.perform();
        }
      }), null, "loadPayments", null));
    }
    get hasBillingErrors() {
      return this.hasPaymentErrors && this.payment.hasErrorLoadingData;
    }
    get hasPaymentErrors() {
      return this.payments && !this.payments.every(payment => (0, _compareStrings.areStringsEqual)(payment.status, 'succeeded'));
    }
  }, (_descriptor = _applyDecoratedDescriptor(_class.prototype, "payment", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  })), _class);
  (0, _component.setComponentTemplate)(__COLOCATED_TEMPLATE__, BillingSectionComponent);
});